import { render } from "./displaymodulegverb.vue?vue&type=template&id=6fb67b6f"
import script from "./displaymodulegverb.vue?vue&type=script&lang=js"
export * from "./displaymodulegverb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__